import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const VISIBLE_COUNT = 5;

const TarifsList = ({ tarifs, note }) => {
    const [showAll, setShowAll] = useState(false);

    if (!tarifs?.length) return null;

    const visibleTarifs = showAll ? tarifs : tarifs.slice(0, VISIBLE_COUNT);
    const hiddenCount = tarifs.length - VISIBLE_COUNT;

    return (
        <>
            <ul className="list-unstyled text-muted">
                {visibleTarifs.map((item, index) => (
                    <li key={index} className="mb-2">
                        <strong>{item.title}</strong> : {item.price}
                        {item.note && <span className="small d-block">{item.note}</span>}
                        {item.sublist?.length > 0 && (
                            <div className="small mt-1">
                                {item.sublistTitle && <em>{item.sublistTitle}</em>}
                                <ul className="mb-0">
                                    {item.sublist.map((subItem, subIndex) => (
                                        <li key={subIndex}>{subItem}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
            {hiddenCount > 0 && (
                <button
                    type="button"
                    className="btn btn-sm btn-outline-dark rounded-pill px-3 mb-3 d-inline-flex align-items-center"
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? (
                        <>Voir moins <ChevronUp size={16} className="ms-1" /></>
                    ) : (
                        <>Voir tous les tarifs ({hiddenCount} de plus) <ChevronDown size={16} className="ms-1" /></>
                    )}
                </button>
            )}
            {note && <p className="small text-muted mb-0">{note}</p>}
        </>
    );
};

export default TarifsList;
